export default __webpack_public_path__ + "static/media/ico_img.320ccbc6.svg";